export default class api {
  static apiConfig = {
    //  baseUrl: 'http://localhost:8019/api',
    // 测试服
    //baseUrl:'http://apitest.haiouchat.com/api/',
    // 正式服
    baseUrl: 'https://api.haiouchat.com/api/',
    // 通过密码登陆
    uploadUrl: '/sysUser/login',
    login: '/sysUser/login',

    //获取页面数据
    getAwards: '/awards',

    getPrizeUser: '/awards/h5/prize/user',

    doAwards: '/awards/h5/raffle',

    //getSurplusShare: '/awards/h5/surplusShare',
    


  };
}



// WEBPACK FOOTER //
// ./src/api/api.js